import { Typography, Box } from '@mui/material';

function SectionItems({ items }) {
  return (
    <Box component="ul" sx={{ mt: 0, pl: 2 }}>
      {items.map((item, i) => (
        <Box
          component="li"
          key={item.label + i}
          sx={{ listStyleType: 'none' }}
        >
          <Typography component="span">
            <strong>{item.label}</strong>
            {item.message && ` - ${item.message}`}
            {item.suffix && ` — ${item.suffix}`}
          </Typography>
          {item.children?.length > 0 && (
            <Box component="ul" sx={{ mt: 0 }}>
              {item.children.map((child, j) => (
                <Typography component="li" key={j}>{child}</Typography>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default function RouteMessage({ message }) {
  if (!message) return null;

  if (typeof message === 'string') {
    return (
      <Typography textAlign="center" sx={{ whiteSpace: 'pre-wrap' }}>
        {message}
      </Typography>
    );
  }

  const { prefix, action, success, errorText, sections } = message;

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography>
        {prefix && (
          <>
            <strong>{prefix}</strong>{' '}
          </>
        )}
        {action} was{' '}
        <strong>{success ? 'successful' : 'unsuccessful'}</strong>.
      </Typography>

      {errorText && (
        <Typography sx={{ mt: 1 }}>{errorText}</Typography>
      )}

      {sections?.map((section, i) => (
        <Box key={section.title + i} sx={{ mt: 1 }}>
          <Typography>
            <strong><u>{section.title}</u></strong>
          </Typography>
          {section.message && (
            <Typography>{section.message}</Typography>
          )}
          {section.items?.length > 0 && (
            <Box sx={{ textAlign: 'left' }}>
              <SectionItems items={section.items} />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
